<template lang="html">
  <span class="search-clients">
    <h-btn @click="display=true" flat color="primary">Start A Conversation</h-btn>
    <modal v-if="display" @close="display=false" btn="Save" title="Clients">
      <h-input @keypress="searchClients" type="text" v-model="search" @input="empty=false" prepend-icon="search" label="Search Clients"/>
      <div v-if="loading" class="small-top">Loading</div>
      <div v-if="empty" class="small-top">No clients found for {{search}}</div>
      <div v-if="clients.length" class="small-top">Select Client</div>
      <div class="client-select small-top" v-if="clients.length">
        <div v-for="client in clients" :key="client.id" class="clients" @click="select(client)">
          <avatar :image="client.image"></avatar>
          <span>{{client.first_name}} {{client.last_name}}</span>
        </div>
      </div>
  </modal>
  </span>
</template>

<script>
import dataStore from "@/services/api/store";
import modal from "@/components/modal/default";
import avatar from "@/components/userImg";
const MESSAGES_ROOM_STORE = "CoachMessagingRooms";
const CLIENTS_STORE = "CoachClients";

export default {
  components: {
    modal,
    avatar
  },
  data() {
    return {
      display: false,
      clients: [],
      search: "",
      loading: false,
      empty: false
    };
  },
  methods: {
    select(client) {
      this.loading = true;
      this.clients = [];
      dataStore
        .findAll(MESSAGES_ROOM_STORE, { client: client.id }, { force: true })
        .then(rooms => {
          this.$emit("newRoom", rooms[0]);
          this.close();
        })
        .then(() => {
          this.loading = false;
        });
    },
    searchClients() {
      clearTimeout(this.timeout);
      this.clients = [];
      if (!this.search) {
        return;
      }
      this.loading = true;
      this.empty = false;
      this.timeout = setTimeout(() => {
        dataStore
          .findAll(
            CLIENTS_STORE,
            {
              search: this.search
            },
            { force: true }
          )
          .then(clients => {
            this.clients = clients;
            if (clients.length === 0) {
              this.empty = true;
            }
            this.loading = false;
          });
      }, 200);
    },
    close() {
      this.clients = [];
      this.display = false;
      this.empty = false;
      this.loading = false;
      this.search = "";
    }
  }
};
</script>

<style lang="less">
.search-clients {
  .clients {
    align-content: center;
    display: flex;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
      margin-right: 5px;
    }
    :hover {
      cursor: pointer;
    }
  }
  .client-select {
    border-style: solid;
    border-width: 1px;
    max-height: 300px;
    overflow: auto;
    padding: 5px;
  }
  .search-field {
    display: flex;
    align-items: center;
  }
}
</style>
